import { Http } from "../Http";
import { ApiResponse } from "../../../Api/Model/ApiResponse.csharp";

export interface ICvUploadApi {
  uploadCv(
    data: FormData
  ): Promise<ApiResponse>;
}

export class CvUploadApi implements ICvUploadApi {
  public uploadCv = (
      data: FormData
  ): Promise<ApiResponse> => {
    return Http.post(
      `/api/upload-cv`, 
        data, 
        "multipart/form-data"
    ) as Promise<ApiResponse>;
  };
}
